import { FelaCSS } from '@bridebook/ui';
import { ISharedTypes as IStyleProps } from './before-well-section-wrap';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = ({ isBefore }: IStyleProps): IStyles => ({
  wrapper: {
    ...(isBefore && {
      marginBottom: '24px',

      maxWidthTabletSm: {
        marginBottom: '0',
      },
    }),
  },
});

export default styles;
